import {ImageOpDefinition, EvaluatedImageOpParameters} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {DataType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {z} from "zod/v4-mini"

export const imageOpHalOptions = z.optional(
    z.object({
        usePhysicalOutputImage: z.optional(z.boolean()), // default: false
        physicalOutputDataType: z.optional(DataType), // default: float32
    }),
)
export type ImageOpHalOptions = z.infer<typeof imageOpHalOptions>

export type ImageOpHalParameters<Definition extends ImageOpDefinition> = EvaluatedImageOpParameters<ImageOpParametersOfType<Definition, "hal">>

export type ExtUpdateImageOptions = UpdateImageOptions & {cachingEnabled: boolean}

export type CachingStrategy =
    | "never" // never store in atlas for reuse
    | "always" // always store in atlas for reuse
    | "auto" // automatically determine based on number of updates before invalidation

export type UpdateImageOptions = {
    priority?: number // default: 0; highest priority is processed first
    abortSignal?: AbortSignal
}
